/**
 * Only allow http(s) links. Catalog fields like `trust_center_url` are stored
 * from externally-influenced sources and validated on the backend with Zod's
 * `.url()`, which accepts any WHATWG-parseable scheme (including `javascript:`).
 * Refuse non-http schemes before rendering an anchor href to avoid a stored
 * anchor-href XSS (CWE-79).
 */
export function safeHttpUrl(url: string | null | undefined): string | undefined {
    return url && /^https?:\/\//i.test(url) ? url : undefined;
}
